import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant';
import 'vant/lib/index.css'
import axios from 'axios'
import './global.css'

Vue.use(Vant)
axios.defaults.withCredentials = true
Vue.config.productionTip = false
Vue.prototype.$http = axios.create({baseURL: 'https://www.bjbayes.com/hongfei/profit'})
//Vue.prototype.$http = axios.create()

// router.beforeEach((to, from, next) => {

// })


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
